module.exports = __webpack_public_path__ + "static/media/document-dark.b355cae4.svg";